import React, { useEffect, useState } from "react";
import {
  Card,
  Tag,
  Typography,
  Row,
  Col,
  Table,
  Tooltip,
  Modal,
  Select,
  Button,
  Input,
  Form,
  InputNumber,
  Radio,
  Popconfirm,
} from "antd";
import { useLocation, useHistory } from "react-router-dom";
import { deleteApi, postReq } from "../api";
import { toastNotification } from "../utils/toasthelper";
import useUserDetails from "../utils/useUserDetails";
import { DeleteOutlined, FileTextOutlined } from "@ant-design/icons";
const { Option } = Select;

const { Title, Text } = Typography;
const { TextArea } = Input;

const JobCard = () => {
  const location = useLocation();
  const history = useHistory();
  console.log("/*/*/*/*/*/*/*/*", location.state);
  const data = location.state.data;
  const [query, setQuery] = useState({
    limit: 10,
    page: 1,
  });
  const [applicationList, setApplicationList] = useState([]);
  const [isLoading, setIsLoading] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [SelectedApplication, setSelectedApplication] = useState({});
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedFile, setSelectedFile] = useState("");
  const [finalBudget, setFinalBudget] = useState(0);
  const [editModal, setEditModal] = useState(false);
  const [requiredTechOptions, setRequiredTechOptions] = useState([]);
  const [techNicheOptions, setTechNicheOptions] = useState([]);
  const [client, setClients] = useState([]);
  const { userRole, permissions, userDetails } = useUserDetails();
  const columns = [
    {
      title: "Candidate Name",
      key: "candidateId",
      render: (_, record) => record.candidateId?.name || "-",
    },
    {
      title: "Budget",
      dataIndex: "budget",
      key: "budget",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: 300,
      render: (text) => (
        <div
          style={{
            maxWidth: 300,
            whiteSpace: "normal",
            wordBreak: "break-word",
          }}
        >
          {text}
        </div>
      ),
    },
    {
      title: "Final Budget",
      dataIndex: "finalBudget",
      key: "final_budget",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Applied Date",
      dataIndex: "createdAt",
      key: "appliedDate",
      render: (date) =>
        date ? new Date(date).toLocaleDateString("en-GB") : "-",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <div
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <Tooltip placement="top" title="Change Status">
            <svg
              width="20"
              height="20"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={() => handleClick(record)}
            >
              <path
                d="M16.625 13.608L11.6667 18.5663C11.2315 19.0003 10.6307 19.25 10.017 19.25H9.33333V18.5663C9.33333 17.9433 9.576 17.3577 10.017 16.9167L14.9753 11.9583L16.625 13.608ZM17.8418 9.09183L16.625 10.3087L18.2747 11.9583L19.4915 10.7415C19.9465 10.2865 19.9465 9.54683 19.4915 9.09183C19.0505 8.64967 18.2817 8.64967 17.8418 9.09183ZM28 5.83333V22.1667C28 25.3832 25.3832 28 22.1667 28H5.83333C2.61683 28 0 25.3832 0 22.1667V5.83333C0 2.61683 2.61683 0 5.83333 0H22.1667C25.3832 0 28 2.61683 28 5.83333ZM21.1423 7.44217C19.8193 6.12033 17.514 6.12033 16.1922 7.44217L8.36733 15.267C7.4865 16.1478 7 17.3203 7 18.5663V20.4167C7 21.0618 7.52267 21.5833 8.16667 21.5833H10.017C11.263 21.5833 12.4355 21.098 13.3163 20.216L21.1412 12.3912C22.5062 11.0262 22.5073 8.80717 21.1423 7.44217Z"
                fill="#666666"
              />
            </svg>
          </Tooltip>
          <Tooltip placement="top" title="Resume">
            {/* https://rmt.cloudStakes.com/api/ */}
            <a
              href={`https://rmt.cloudStakes.com/files/${record.resume}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FileTextOutlined
                style={{ fontSize: "20px", marginTop: "5px" }}
              />
            </a>
          </Tooltip>
          <Popconfirm
            title="Delete Candidate"
            description="Are you sure you want to delete this candidate?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => deleteCandidate(record._id)}
          >
            <Tooltip placement="top" title="Delete Candidate">
              <DeleteOutlined
                style={{
                  fontSize: "20px",
                  width: "20",
                  height: "20",
                  color: "red",
                  marginTop: "4px",
                }}
              />
            </Tooltip>
          </Popconfirm>
        </div>
      ),
    },
  ];
  const profileStatusOptions = [
    {
      label: "Waiting",
      value: "waiting",
    },
    {
      label: "Screening",
      value: "screening",
    },
    {
      label: "Interview",
      value: "interview",
    },
    {
      label: "Rejected",
      value: "rejected",
    },
    {
      label: "On-Hold",
      value: "hold",
    },
    {
      label: "Pending",
      value: "pending",
    },
    {
      label: "Selected",
      value: "selected",
    },
  ];

  const requirementTypeOptions = [
    {
      value: "Fte",
      _id: "Fte",
    },
    {
      value: "Contractual",
      _id: "Contractual",
    },
  ];
  const [form] = Form.useForm();
  const status = Form.useWatch("status", form);

  const deleteCandidate = async (id) => {
    try {
      const res = await deleteApi(`/company/candidate_applied/${id}`);
      if (res.data.status === 200) {
        toastNotification("success", "Candidate deleted successfully");
        getApplications();
      } else {
        toastNotification(
          "error",
          res.data.message || "Unable to delete candidate",
        );
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleTagsData = async (isRequiredTech) => {
    try {
      let type = isRequiredTech ? "requiredTech" : "techNiche";

      const callResponse = await postReq("/common/getTags", {
        type: type,
      });

      if (callResponse.status === 1) {
        if (isRequiredTech) {
          setRequiredTechOptions(callResponse.data.tags);
        } else {
          setTechNicheOptions(callResponse.data.tags);
        }
      }
    } catch (error) {
      console.log("error ", error);
    }
  };
  const handleClick = (record) => {
    setSelectedApplication(record);
    setShowModal(!showModal);
  };

  const fetchClient = async () => {
    let response;
    response =
      userRole == "company"
        ? await postReq("company/clients/dropdown", {})
        : permissions.includes("update_requirements")
          ? await postReq("common/clients/dropdown", {})
          : { status: 201 };
    if (response.status == 200) {
      setClients(response.data);
    } else {
      setClients([]);
    }
  };
  useEffect(() => {
    fetchClient();
    getApplications();
    handleTagsData(true);
    handleTagsData(false);
  }, [query, userRole]);

  const getApplications = async () => {
    try {
      setIsLoading(true);
      const getJob = await postReq("/company/candidate_applied", {
        ...query,
        requirementId: data._id,
      });
      if (getJob.status === 200) {
        setApplicationList(getJob?.data);
        setIsLoading(false);
      } else {
        setApplicationList([]);
        setIsLoading(false);
        toastNotification("error", getJob.message);
      }
    } catch (error) {
      toastNotification("error", error.message);
    }
  };

  const handleCancel = () => {
    setShowModal(!showModal);
    setSelectedApplication({});
  };
  const handleEditCancel = () => {
    setEditModal(!editModal);
  };

  const handleChange = (value) => {
    setSelectedStatus(value);
  };

  const handleFileChange = ({ file }) => {
    setSelectedFile(file); // Update selected file state
  };

  const handleBudgetChange = (e) => {
    setFinalBudget(e.target.value);
  };

  const handleEditClick = () => {
    setEditModal(!editModal);
  };

  const handleSubmit = async (editData) => {
    try {
      let newData = { ...editData };
      setIsLoading(true);
      newData.requirementId = data._id;
      // newData.companyId = "6631dfd0eb64c21aab3760bc";
      let postData;
      postData =
        userRole == "company"
          ? await postReq("/company/requirement/update", newData, {})
          : permissions.includes("update_requirements")
            ? await postReq("/common/requirement/update", newData, {})
            : null;

      if (postData.status === 1) {
        toastNotification("success", postData.message);
        form.resetFields();
        setIsLoading(false);
        setEditModal(false);
        history.push(`/company/requirements`);
      } else {
        toastNotification("error", postData.message);
        form.resetFields();
        setEditModal(false);
        setIsLoading(false);
      }
    } catch (error) {
      console.log("error", error);
      toastNotification("error", "Something went wrong, Try again");
      form.resetFields();
      setEditModal(false);
      setIsLoading(false);
    }
  };

  // const [showFull, setShowFull] = useState(false);
  // const toggleShowMore = () => setShowFull((prev) => !prev);

  const handleStatus = async (values) => {
    const response = await postReq("company/candidate_applied/update", {
      ...values,
      id: SelectedApplication._id,
    });

    if (response.status == 200) {
      setSelectedApplication(null);
      setShowModal(false);
      getApplications();
    } else {
      toastNotification("error", response.message);
    }
  };
  useEffect(() => {
    if (SelectedApplication) {
      form.setFieldsValue({
        status: SelectedApplication.status,
        description: SelectedApplication.description,
        finalBudget: SelectedApplication.finalBudget
          ? Number(SelectedApplication.finalBudget)
          : undefined,
      });
    }
  }, [SelectedApplication, form]);

  return (
    <>
      <Modal
        open={showModal}
        className="cvUpdate"
        style={{ borderRadius: "10px" }}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={isLoading}
            onClick={() => form.submit()}
          >
            OK
          </Button>,
        ]}
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "16px",
              // background: "#F4F4F4",
            }}
          >
            <div>
              <Title
                level={4}
                style={{
                  marginBottom: 0,
                  fontSize: "16px",
                  fontWeight: "700",
                }}
              >
                Update Cv Screening Status
              </Title>
            </div>
            <svg
              width="24"
              height="24"
              viewBox="0 0 38 38"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={handleCancel}
            >
              <circle cx="19" cy="19" r="19" fill="white" />
              <path
                d="M13.4854 13.4852L25.0001 25"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M25 13.4852L13.4853 25"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </div>
        }
      >
        <Form form={form} layout="vertical" onFinish={handleStatus}>
          <Form.Item
            label="Candidate Status"
            name="status"
            rules={[
              { required: true, message: "Please enter requirement status" },
            ]}
          >
            <Select
              style={{ width: "100%" }}
              placeholder="Select a status"
              label="Select a status"
            >
              {profileStatusOptions.map((data, i) => (
                <Option key={i} value={data.value}>
                  {data.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Description"
            name="description"
            rules={[{ required: true, message: "Please enter description" }]}
          >
            <TextArea rows={4} placeholder="Enter rejection remarks" />
          </Form.Item>
          {/* {status === "selected" && ( */}
          <Form.Item
            label="Selected Budget"
            name="finalBudget"
            rules={[
              {
                required: status == "selected",
                message: "Please enter Budget",
              },
            ]}
          >
            <InputNumber
              style={{ width: "100%" }}
              placeholder="Enter Final Budget"
              disabled={status !== "selected"}
            />
          </Form.Item>
          {/* )} */}
        </Form>
      </Modal>

      <Card
        bordered={false}
        style={{ width: "100%", borderRadius: 10, overflow: "hidden" }}
      >
        <Row justify="space-between" align="middle">
          <Col style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            <svg
              width="12"
              height="19"
              viewBox="0 0 12 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={() => {
                history.push("/company/requirements");
              }}
              style={{ fontSize: "20px", cursor: "pointer" }}
            >
              <path
                d="M10.5 2L3 9.5L10.5 17"
                stroke="#666666"
                stroke-width="3"
                stroke-linecap="round"
              />
            </svg>

            <Title
              level={4}
              style={{ margin: 0, fontSize: "20px", fontWeight: "700" }}
            >
              {data.requirementName}
            </Title>
            <svg
              width="4"
              height="24"
              viewBox="0 0 4 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              cursor="pointer"
            >
              <path
                d="M2 2L2 26"
                stroke="#D6D6D6"
                stroke-width="3"
                stroke-linecap="round"
              />
            </svg>

            <Tag
              color="#E7F1FC"
              style={{
                border: "1px solid #C1D6EE",
                borderRadius: "12px",
                padding: "1px 8px",
                fontSize: "10px",
              }}
            >
              <span style={{ color: "#13487D", fontWeight: "600" }}>
                Job ID {data.jobId}
              </span>
            </Tag>
          </Col>
          <Col>
            {(userRole == "company" ||
              permissions?.includes("update_requirements")) && (
              <svg
                width="44"
                height="44"
                viewBox="0 0 64 64"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                cursor="pointer"
                onClick={() => handleEditClick()}
              >
                <rect width="64" height="64" rx="18" fill="#F4F4F4" />
                <path
                  d="M31.0871 29.4692L30.051 32.5787C29.9906 32.7694 29.9837 32.973 30.0311 33.1674C30.0785 33.3617 30.1785 33.5392 30.3199 33.6806C30.4614 33.822 30.6391 33.9218 30.8334 33.9691C31.0277 34.0164 31.2313 34.0093 31.422 33.9487L34.5312 32.9126C34.6903 32.8591 34.8349 32.7698 34.9539 32.6514L42.2539 25.3506C42.7317 24.8723 43 24.2238 43 23.5477C43 22.8716 42.7317 22.2231 42.2539 21.7447C41.7753 21.2678 41.1273 21 40.4517 21C39.776 21 39.128 21.2678 38.6494 21.7447L31.3493 29.0465C31.2303 29.1652 31.1406 29.3099 31.0871 29.4692Z"
                  fill="#13487D"
                />
                <path
                  d="M41.9 28.7C41.6083 28.7 41.3285 28.8159 41.1222 29.0222C40.9159 29.2285 40.8 29.5083 40.8 29.8V37.5C40.8 38.3752 40.4523 39.2146 39.8335 39.8335C39.2146 40.4523 38.3752 40.8 37.5 40.8H26.5C25.6248 40.8 24.7854 40.4523 24.1665 39.8335C23.5477 39.2146 23.2 38.3752 23.2 37.5V26.5C23.2 25.6248 23.5477 24.7854 24.1665 24.1665C24.7854 23.5477 25.6248 23.2 26.5 23.2H34.2C34.4917 23.2 34.7715 23.0841 34.9778 22.8778C35.1841 22.6715 35.3 22.3917 35.3 22.1C35.3 21.8083 35.1841 21.5285 34.9778 21.3222C34.7715 21.1159 34.4917 21 34.2 21H26.5C25.0418 21.0017 23.6439 21.5818 22.6128 22.6128C21.5818 23.6439 21.0017 25.0418 21 26.5V37.5C21.0017 38.9582 21.5818 40.3561 22.6128 41.3872C23.6439 42.4182 25.0418 42.9983 26.5 43H37.5C38.9582 42.9983 40.3561 42.4182 41.3872 41.3872C42.4182 40.3561 42.9983 38.9582 43 37.5V29.8C43 29.5083 42.8841 29.2285 42.6778 29.0222C42.4715 28.8159 42.1917 28.7 41.9 28.7Z"
                  fill="#13487D"
                />
              </svg>
            )}
          </Col>
        </Row>

        {/* <Row style={{ marginTop: 15 }}>
          <Col>
            <Space>
              <svg
                width="14"
                height="18"
                viewBox="0 0 14 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.75 0C3.0285 0 0 3.0495 0 6.79875C0 12.126 6.1155 17.6265 6.37575 17.8575C6.483 17.9527 6.6165 18 6.75 18C6.8835 18 7.017 17.9528 7.12425 17.8582C7.3845 17.6265 13.5 12.126 13.5 6.79875C13.5 3.0495 10.4715 0 6.75 0ZM6.75 10.5C4.68225 10.5 3 8.81775 3 6.75C3 4.68225 4.68225 3 6.75 3C8.81775 3 10.5 4.68225 10.5 6.75C10.5 8.81775 8.81775 10.5 6.75 10.5Z"
                  fill="#A7A7A7"
                />
              </svg>

              <Text
                style={{
                  color: "#666666",
                  marginBottom: "6px",
                  fontSize: "18px",
                }}
              >
                {data.jobLocation}
              </Text>
              <svg
                width="4"
                height="24"
                viewBox="0 0 4 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                cursor="pointer"
              >
                <path
                  d="M2 2L2 26"
                  stroke="#D6D6D6"
                  stroke-width="3"
                  stroke-linecap="round"
                />
              </svg>
              <Text>{data.workType}</Text>
            </Space>
          </Col>
        </Row> */}

        <div
          style={{
            border: "1.5px dashed #D6D6D6",
            borderRadius: "12px",
            padding: "16px",
            marginTop: "16px",
          }}
          px
        >
          <Row>
            <Col>
              <Text
                style={{
                  fontSize: "20px",
                  fontWeight: "600",
                  marginBottom: "40px",
                }}
              >
                Job Description
              </Text>
            </Col>

            <Col span={24} style={{ marginTop: "20px" }}>
              <Text
                style={{
                  fontSize: "16px",
                  color: "#666666",
                  whiteSpace: "pre-wrap",
                  marginTop: "20px",
                  // maxHeight: showFull ? "100%" : "200px",
                  // overflow: "hidden",
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  // WebkitLineClamp: showFull ? "none" : 3,
                  overflow: "auto",
                }}
              >
                {data.requirementJobDescription}
              </Text>
              {/* <div>
                <a
                  onClick={toggleShowMore}
                  style={{
                    color: "#1890ff",
                    marginTop: "10px",
                    display: "block",
                    cursor: "pointer",
                  }}
                >
                  {showFull ? "Show Less" : "Show More"}
                </a>
              </div> */}
            </Col>
          </Row>
          {applicationList?.length > 0 && (
            <Row
              style={{
                marginTop: 30,
              }}
            >
              <Col
                span={24}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "20px",
                }}
              >
                <Text style={{ fontSize: "20px", fontWeight: "600" }}>
                  Application
                </Text>
              </Col>
              <Col span={24}>
                <Table
                  columns={columns}
                  dataSource={applicationList}
                  loading={isLoading}
                  scroll={{ x: "max-content" }}
                  pagination={false}
                />
              </Col>
            </Row>
          )}
        </div>
      </Card>
      {console.log("data", data)}
      <Modal
        title="Edit Your Requirement"
        open={editModal}
        onCancel={handleEditCancel}
        footer={null}
        width="70%" // Full width on mobile
        style={{ top: 20 }}
        bodyStyle={{ padding: 10 }}
        responsive={true}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={{
            requirementName: data.requirementName,
            requirementType: data.requirementType,
            requirementNiche: data.requirementNiche.map((tech) => tech._id),
            clientId: data.clientId,
            // requiredTechnology: data.requiredTechnology.map((tech) => tech._id),
            minExperience: Number(data.minExperience),
            maxExperience: Number(data.maxExperience),
            jobLocation: data.jobLocation,
            budget: data.budget,
            requirementJobDescription: data.requirementJobDescription,
            requirementStatus: data.requirementStatus,
            workType: data.workType,
            vacancy: data.vacancy,
          }}
        >
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Requirement Name"
                name="requirementName"
                rules={[
                  { required: true, message: "Please enter requirement name" },
                ]}
              >
                <Input
                  placeholder="Enter"
                  value={data.requirementName}
                  maxLength={40}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Select Client"
                name="clientId"
                rules={[{ required: true, message: "Please select Client" }]}
              >
                <Select
                  placeholder="Select"
                  className="ant-select-selection1"
                  // dropdownStyle={{
                  //   backgroundColor: "#fff",
                  //   borderRadius: "8px",
                  // }}
                  // dropdownClassName="custom-dropdown"
                >
                  {client.length > 0 &&
                    client.map((data, i) => (
                      <Option key={i} value={`${data.value}`}>
                        {data.label}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Select Requirement Type"
                name="requirementType"
                rules={[
                  { required: true, message: "Please select requirement type" },
                ]}
              >
                <Select placeholder="Select" className="ant-select-selection1">
                  {requirementTypeOptions.length > 0 &&
                    requirementTypeOptions.map((data, i) => (
                      <Option key={i} value={`${data._id}`}>
                        {data.value}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Select Technology Niche"
                name="requirementNiche"
                rules={[
                  { required: true, message: "Please select technology niche" },
                  {
                    validator: (_, value) => {
                      if (!value || value.length < 1) {
                        return Promise.reject(
                          new Error("At least one niche is required"),
                        );
                      }
                      if (value.length > 10) {
                        return Promise.reject(
                          new Error("You can add at most 10 niches"),
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Select
                  mode="multiple" // Enables multi-select
                  placeholder="Technology Niche"
                  allowClear
                  style={{ width: "100%" }}
                  maxTagCount="responsive"
                >
                  {techNicheOptions.length > 0 &&
                    techNicheOptions.map((data, i) => (
                      <Option key={i} value={data._id}>
                        {data.value}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Enter Minimum Experience"
                name="minExperience"
                rules={[
                  {
                    required: true,
                    message: "Please enter minimum experience",
                  },
                  {
                    type: "number",
                    min: 1,
                    message: "Minimum Experience should be at least 1 year",
                  },
                  {
                    type: "number",
                    max: 15,
                    message:
                      "Minimum Experience should be less than or equal to 14 years",
                  },
                ]}
              >
                <InputNumber placeholder="Enter" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Enter Maximum Experience"
                name="maxExperience"
                rules={[
                  {
                    required: true,
                    message: "Please enter maximum experience",
                  },
                  {
                    type: "number",
                    min: 1,
                    message: "Maximum Experience should be at least 1 year",
                  },
                  {
                    type: "number",
                    max: 18,
                    message:
                      "Maximum Experience should be less than or equal to 18 years",
                  },
                ]}
              >
                <InputNumber placeholder="Enter" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Enter Job Location"
                name="jobLocation"
                rules={[
                  { required: true, message: "Please enter job location" },
                ]}
              >
                <Input placeholder="Enter" maxLength={30} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Enter Budget"
                name="budget"
                rules={[{ required: true, message: "Please enter budget" }]}
              >
                <Input placeholder="Enter" maxLength={7} />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            label="Enter Job Description"
            name="requirementJobDescription"
            rules={[
              { required: true, message: "Please enter job description" },
              {
                min: 100,
                message: "Description must be at least 100 characters",
              },
            ]}
          >
            <Input.TextArea
              style={{ height: 100, resize: "vertical" }}
              placeholder="Enter"
            />
          </Form.Item>
          <Row>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                label="Work Status"
                name="workType"
                rules={[
                  { required: true, message: "Please select work type status" },
                ]}
              >
                <Radio.Group>
                  <Radio value="onsite">Onsite</Radio>
                  <Radio value="remote">Remote</Radio>
                  <Radio value="hybrid">Hybrid</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={4}>
              <Form.Item
                label="Vacancy"
                name="vacancy"
                rules={[
                  { required: true, message: "Please enter vacancy" },
                  {
                    type: "number",
                    min: 1,
                    message: "Minimum Vacancy should be at least 1",
                  },
                  {
                    type: "number",
                    max: 999,
                    message:
                      "Maximum Vacancy should be less than or equal to 999",
                  },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder="Enter Vacancy"
                />
              </Form.Item>
            </Col>
          </Row>
          {/* <Row gutter={16}>
            <Col xs={24} sm={8}>
              <Form.Item
                label="Requirement Status"
                name="requirementStatus"
                rules={[
                  {
                    required: true,
                    message: "Please select requirement status",
                  },
                ]}
              >
                <Radio.Group>
                  <Radio value="open">Open</Radio>
                  <Radio value="close">Close</Radio>
                  <Radio value="on-hold">On-Hold</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>

            <Col xs={24} sm={8}>
              <Form.Item
                label="Work Status"
                name="workType"
                rules={[
                  { required: true, message: "Please select work Type status" },
                ]}
              >
                <Radio.Group>
                  <Radio value="onsite">Onsite</Radio>
                  <Radio value="remote">Remote</Radio>
                  <Radio value="hybrid">Hybrid</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item
                label="Enter Vacancy"
                name="vacancy"
                rules={[{ required: true, message: "Please enter vacancy" }]}
              >
                <InputNumber placeholder="Enter Vacanvy" />
              </Form.Item>
            </Col>
          </Row> */}

          <Form.Item style={{ textAlign: "right" }}>
            <Button
              type="default"
              onClick={handleCancel}
              style={{ marginRight: 8 }}
            >
              Reset
            </Button>
            <Button type="primary" htmlType="submit" loading={isLoading}>
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
const JobDescription = ({ data }) => {
  const [showFull, setShowFull] = useState(false);

  const toggleShowMore = () => setShowFull(!showFull);

  const textStyle = showFull
    ? {} // Full text, no clamping
    : {
        display: "-webkit-box",
        WebkitLineClamp: 3, // Show only 3 lines
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
      };

  return (
    <Row>
      <Col span={24} style={{ marginTop: "20px" }}>
        <Text
          style={{
            fontSize: "16px",
            color: "#666666",
            whiteSpace: "pre-wrap",
            marginTop: "20px",
            ...textStyle,
          }}
        >
          {data.requirementJobDescription}
        </Text>
        {/* <div>
          <a
            onClick={toggleShowMore}
            style={{
              color: "#1890ff",
              marginTop: "10px",
              display: "block",
              cursor: "pointer",
            }}
          >
            {showFull ? "Show Less" : "Show More"}
          </a>
        </div> */}
      </Col>
    </Row>
  );
};

export default JobCard;
